import { localStg } from '@/utils/storage/local';
import { EnumLocalStore } from '@/constant/enums';

export const envConfig = {
    cnApi: process.env.NODE_ENV === 'production' ? 'https://server.cottongame.com' : 'https://server.cottongame.com',
    overseaApi: process.env.NODE_ENV === 'production' ? 'https://oversea-server.cottongame.com' : 'https://oversea-server.cottongame.com',
    getCurrentApi: () => {
        let region = localStg.get(EnumLocalStore.region);
        if (!region) {
            return envConfig.cnApi;
        }
        return region.toLocaleLowerCase() === 'oversea' ? envConfig.overseaApi : envConfig.cnApi;
    }
}
